import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const creditScoreSlice = createSlice({
    name: "creditScore",
    initialState: {
        page: 0,
        pageCount: 0,
        listData: null,
    },
    reducers: {
        doGetCreditScoreListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload.current_page;
            state.pageCount = action.payload.page_count;
        },
        doGetCreditScoreListFail: (state) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
        },
        resetCreditScoreState: (state) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
        },
    },
});

export const doGetCreditScoreList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/credit-score?page=${param.page}&size=${param.limit}`;
        if (param.keyword) url += `&keyword=${encodeURIComponent(param.keyword)}`;
        if (param.sort_by) url += `&sort_by=${param.sort_by}`;

        const response = await axios.get(url);
        dispatch(doGetCreditScoreListSuccess(response.data));
    } catch (error) {
        dispatch(doGetCreditScoreListFail(error.response));
    }
};

export const {
    doGetCreditScoreListSuccess, doGetCreditScoreListFail,
    resetCreditScoreState,
} = creditScoreSlice.actions;

export const getCreditScoreList = (state) => state.creditScore?.listData;
export const getCreditScoreListPage = (state) => state.creditScore?.page;
export const getCreditScoreListPageCount = (state) => state.creditScore?.pageCount;

export default creditScoreSlice.reducer;
